module.exports = __webpack_public_path__ + "img/NO937891423.dc148a73.png";